import { marked } from 'marked';
import DOMPurify from 'dompurify';

export const SanitizedMarkedHtml = (text: string) => {
  if (!text) {
    return '';
  }
  const html = marked.parse(text.replace(/\n/g, '  \n'));
  return typeof html === 'string' ? DOMPurify.sanitize(html) : '';
};
